// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"823":"7ff52422","971":"dbbea4e4"}[chunkId] + ".chunk.js";
};